<template>
  <!-- ================ start footer Area ================= -->
  <footer class="footer-area section-gap">
		<div class="container">
			<div class="row">
				<div class="col-xl-4 col-sm-6 mb-4 mb-xl-0 single-footer-widget" style="display:none;">
					<h4>Our Features</h4>
					<ul>
						<li><router-link to="/retention-flow">Retention Flow™</router-link></li>
						<li><router-link to="/retention-link">Retention Link™</router-link></li>
						<li><router-link to="/retention-analytics">Retention Analytics™</router-link></li>
					</ul>
				</div>
				<div class="col-xl-4 col-sm-6 mb-4 mb-xl-0 single-footer-widget">
					<h4>Quick Links</h4>
					<ul>
						<li><router-link to="/">Features</router-link></li>
						<li><router-link to="/pricing">Pricing</router-link></li>
						<li><a style="cursor:pointer;" onclick="window.location.href = 'https://app.retainerdesk.com/#/register'">Try it free</a></li>
						<li><router-link to="/contact">Contact</router-link></li>
						<li><a href="https://blog.retainerdesk.com/">Retention Blog</a></li>
					</ul>
				</div>
				<div class="col-xl-4 col-sm-6 mb-4 mb-xl-0 single-footer-widget">
					<h4>Industries</h4>
					<ul>
						<li><router-link to="/reduce-churn-saas">SaaS subscriptions</router-link></li>
						<li><router-link to="/reduce-churn-bank-insurance">Bank & Insurance</router-link></li>
						<li><router-link to="/reduce-churn-physical-products">Physical producs</router-link></li>
						<li><router-link to="/reduce-churn-telecom">Telecom & Mobile</router-link></li>
					</ul>
				</div>
				<div class="col-xl-2 col-sm-6 mb-4 mb-xl-0 single-footer-widget" style="display:none;">
					<h4>Resources</h4>
					<ul>
						<li><a href="#">Guides</a></li>
						<li><a href="#">Research</a></li>
						<li><a href="#">Experts</a></li>
						<li><a href="#">Agencies</a></li>
					</ul>
				</div>
				<div class="col-xl-4 col-md-8 mb-4 mb-xl-0 single-footer-widget">
					<h4>Book a demo</h4>
					<p>Send your email and we will come back to you with a time for a demo.</p>
					<div class="form-wrap" id="mc_embed_signup">
						<div class="form-inline">
							<input class="form-control" name="EMAIL" placeholder="Your Email Address" v-model="email" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your Email Address '"
							 required="" type="email">
							<button @click="sendMail()" :disabled="valid" class="click-btn btn btn-default">Book</button>
							<div v-if="valid">Thanks! We will come back to you soon with more details.</div>
							<div style="position: absolute; left: -5000px;">
								<input name="b_36c4fd991d266f23781ded980_aefe40901a" tabindex="-1" value="" type="text">
							</div>

							<div class="info"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer-bottom row align-items-center text-center text-lg-left">
				<p class="footer-text m-0 col-lg-8 col-md-12">
					&copy; 2020 RetainerDesk AB - SE559199775301.<br><a href="tel:+46855109280">Call us +46 8 551 092 80</a>
				</p>
				<div class="col-lg-4 col-md-12 text-center text-lg-right footer-social">
					<a href="https://www.facebook.com/RetainerDesk"><i class="fab fa-facebook-f"></i></a>
					<a href="https://www.linkedin.com/company/retainerdesk/"><i class="fab fa-linkedin"></i></a>
				</div>
			</div>
		</div>
	</footer>
  <!-- ================ End footer Area ================= -->
</template>

<script>
export default {
	data() {
		return {
			email: '',
			valid: false,
		}
	},
	methods: {
		sendMail(data) {

			const obj = {
				from: this.email,
				to: 'taieb@retainerdesk.com'
			}

			if(this.email.length < 3) {
				alert("Your email need to be valid");
				return;
			}

			this.$store.dispatch('SEND_MAIL', obj);
			this.valid = true;
		}
	}

}
</script>

<style>

</style>